import { AsyncReactComponent } from "./AsyncReactComponent";
import * as React from "react";

export interface ISelectOption {
    title: string;
    value: string;
}
export abstract class FormAsyncReactComponent<TProps, TState> extends AsyncReactComponent<TProps, TState>{
    async handleInputChangeAsync(event): Promise<void> {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        var state = ({ ...this.state });
        this.setProperty(state, target.name, value)
        await this.setStateAsync(state);
    }
    private getProperty(name: string, defaultValue?: any) {
        let paths = name.split('.');
        var state: any = { ...this.state };
        if (state === undefined) {
            if (defaultValue) {
                state = {};
                this.setProperty(state, name, defaultValue);
                this.setState(state);
                return defaultValue;
            }
            return undefined;
        }
        var parent = state;
        while (paths.length > 1) {
            const childName = paths.shift();
            let child = parent[childName];
            if (child === undefined) {
                if (defaultValue) {
                    this.setProperty(parent, childName, defaultValue);
                    this.setState(state);
                    return defaultValue;
                }
                return undefined;
            }
            parent = child;
        }
        return parent[paths[0]];
    }
    private setProperty(item: any, name: string, value: any) {
        let paths = name.split('.');
        var parent = item || {};
        while (paths.length > 1) {
            const childName = paths.shift();
            let child = parent[childName];
            if (child === undefined) {
                child = {};
                parent[childName] = child;
            }
            parent = child;
        }
        parent[paths[0]] = value;

    }
    renderTextBox(key: string, label: string, type: string = "text"): JSX.Element {

        return <div className="form-group">
            <label htmlFor={key}>{label}</label>
            <input name={key} type={type} value={this.getProperty(key)} className="form-control" onChange={async (e) => { this.handleInputChangeAsync(e); }} />
        </div>
    }
    renderCheckbox(key: string, label: string): JSX.Element {
        return <div className="checkbox">
            <label>
                <input type="checkbox" name={key}
                    checked={this.getProperty(key)} onChange={async (e) => { await this.handleInputChangeAsync(e); }} />
                {label}
            </label>
        </div>
    }
    renderSelect(key:string, label:string,options: ISelectOption[]){
        let defaultValue = undefined;
        if (options && options.length)
            defaultValue = options[0].value;
        return <div key={"form:comp:" + key} className="form-group">
            <label htmlFor={key}>{label}</label>
            <select className="form-control" name={key} value={this.getProperty(key, defaultValue)}
                onChange={async (e) => { await this.handleInputChangeAsync(e);  }} >
                {options.map(o => <option key={o.value} value={o.value}>{o.title}</option>)}
            </select>
        </div>
    }
}
